import script from "./SensorView.vue?vue&type=script&setup=true&lang=js"
export * from "./SensorView.vue?vue&type=script&setup=true&lang=js"

import "./SensorView.vue?vue&type=style&index=0&id=d669b05a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d669b05a"]])

export default __exports__